import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Tabs from '../Tabs';
import Tab from '../Tab';
import VHSAccordion, { IVHSAccordionProps } from '../VHSAccordion';
import { JSONLD, Generic } from 'react-structured-data';

export interface IVHSFAQsProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Accordions
	 */
	accordions?: IVHSAccordionProps[];
}

/**
 * FAQs
 * @block
 * @icon download
 */
const VHSFAQs: React.FC<IVHSFAQsProps> = ({
	heading,
	accordions = [],
	className,
	classNames = [],
}) => {

	const faqs = accordions.map((accordion, index) => {
		return accordion.items.map(( item, index ) => {
			return {
				"@type": "Question",
				"name": accordion.heading + ' - ' + item.title,
				"acceptedAnswer": {
					"@type": "Answer",
					"text": item.content,
				}
			}
		});
	});

	return (
		<div
			className={className || cn('vhs-faqs', ...classNames)}
		>
			<JSONLD>
				<Generic type='page' jsonldtype="FAQPage" schema={{ mainEntity:faqs }} />
			</JSONLD>
			<div className="vhs-faqs__container">
				{heading && (
					<h2 className="vhs-faqs__heading">{heading}</h2>
				)}
				{accordions && accordions.length > 0 &&
					<div className="vhs-faqs__wrapper">
						<Tabs className="vhs-tabs">
							{accordions.map(( accordion, index) => (
								<Tab
									title={accordion.heading}
									key={index}
								>
									<VHSAccordion
										{...accordion}
									/>
								</Tab>
							))}
						</Tabs>
					</div>
				}
			</div>
		</div>
	);
};

export default VHSFAQs;
